import * as React from 'react';
import PropTypes from 'prop-types';
import Wrapper from './Wrapper';
import Spin from '../Spin';
import Spinner from './Spinner';

const Loading = (props) => {
  const { isLoading, width, height, noBackground, onlyIcon } = props;
  if (onlyIcon) {
    return isLoading && <Spinner width={width} height={height} />;
  }
  return (
    isLoading && (
      <Wrapper noBackground={noBackground}>
        <Spin width={width} height={height} />
      </Wrapper>
    )
  );
};

Loading.propTypes = {
  isLoading: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  noBackground: PropTypes.bool,
  onlyIcon: PropTypes.bool,
};

Loading.defaultProps = {
  isLoading: false,
  width: '20px',
  height: '20px',
  noBackground: false,
  onlyIcon: false,
};

export default Loading;
